var ChartsPlugin = require('utils/charts/charts_plugin');
var ChartsAndroidFix = ChartsPlugin.extend({
    initPlugin: function () {
        if (this.options.noView) return;
        var self = this;
        this.chartView.on('charts:draw:after', function () {
            self.foreachCharts(function (k, g) {
                this.afterDraw(g);
            });
        });
    },

    afterDraw: function (g) {
        if (!g || !g.trovisContext) return;
        var ctx = g.trovisContext;
        if (!ctx.clippingDiv) this.createClippingDiv(g, ctx);

        var area = g.layout_.getPlotArea();
        var $div = $(ctx.clippingDiv);
        $div.css('width', '' + $(g.canvas_).width() + 'px');
        $div.css('height', '' + (ctx.ownerDiv.height() - area.h) + 'px');
        $div.css('top', '' + (area.y + area.h) + 'px');

        var $div = $(ctx.clippingDiv2);
        $div.css('width', '' + area.x + 'px');
        $div.css('height', '' + ctx.ownerDiv.height() + 'px');
        $div.css('top', '0px');
        $div.css('left', '0px');
    },

    findBackgoundColor: function (div) {
        if ($(div).length == 0) return;

        var bgColor = $(div).css('background-color');
        if (bgColor == 'rgba(0, 0, 0, 0)') bgColor = this.findBackgoundColor($(div).parent().first());
        return bgColor;
    },

    createClippingDiv: function (g, ctx) {
        var cd = document.createElement('div');
        var cd2 = document.createElement('div');
        var ownerDiv = $(g.canvas_).parent().first();
        var bgColor = this.findBackgoundColor(ownerDiv);

        var divStyles = {
            'background-color': bgColor,
            position: 'absolute',
            left: '0px',
        };

        ctx.ownerDiv = ownerDiv;
        ctx.clippingDiv = cd;
        ctx.clippingDiv2 = cd2;

        _.each([cd, cd2], function (cd) {
            ownerDiv.append(cd);
            for (var key in divStyles) $(cd).css(key, divStyles[key]);
        });
    },
});

module.exports = ChartsAndroidFix;
